var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-sin-ordenes"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sin-ordenes",
    clipPath: "url(#clip-sin-ordenes)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2314",
    "data-name": "Grupo 2314",
    transform: "translate(-5.734 -19.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.135 39.449)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 76.9,
    height: 76.9,
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(8.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_5eac2be7-c13c-4220-85d1-18a5290e501f",
    "data-name": "5eac2be7-c13c-4220-85d1-18a5290e501f",
    d: "M49.84,4h7.1A7.56,7.56,0,0,1,64.5,11.563V64.5a7.56,7.56,0,0,1-7.563,7.563H11.563A7.56,7.56,0,0,1,4,64.5V11.563A7.56,7.56,0,0,1,11.563,4h6.877",
    transform: "translate(-4 4.661)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "fce76c50-5a59-42c5-a3db-b8a1e57eff7c",
    width: 30.76,
    height: 15.38,
    rx: 1,
    transform: "translate(14.659)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon-3",
    "data-name": "Icon",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 65.059, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area-2",
    "data-name": "Area",
    width: 72.254,
    height: 72.254,
    transform: "translate(0 0)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-4",
    "data-name": "Icon",
    transform: "translate(14.779 10.995)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "b7708727-0152-4c0a-8f17-f21676919a5a",
    y2: 10.63,
    transform: "translate(18.788 0)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "_24c50cd7-edb0-44ec-ac6a-9bc4d7de9699",
    "data-name": "24c50cd7-edb0-44ec-ac6a-9bc4d7de9699",
    x2: 7.521,
    y2: 7.521,
    transform: "translate(0 7.786)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "_16f6e293-67dc-4d24-81d6-2dbddfc10e17",
    "data-name": "16f6e293-67dc-4d24-81d6-2dbddfc10e17",
    x2: 10.63,
    transform: "translate(34.733 26.574)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "_53afa7e3-50dc-4ad6-a348-1bb198125cb2",
    "data-name": "53afa7e3-50dc-4ad6-a348-1bb198125cb2",
    y1: 7.521,
    x2: 7.521,
    transform: "translate(30.055 7.786)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/no-orders.9fd1f249ce6126f408a65a43c3914f50.svg";
export { ForwardRef as ReactComponent };